import React, { FC, ReactNode } from 'react';
import withStyles from 'src/common/withStyles';

import { useFeatureFlag } from 'src/common/hooks';
import { getClassNameFor, decorateComponent } from '../../helpers';
import s from './Header.module.scss';

type BareHeaderProps = {
  children?: ReactNode;
  extraChildren?: ReactNode;
  classNameModifier?: string;
};

const BareHeader: FC<BareHeaderProps> = ({
  children,
  extraChildren,
  classNameModifier,
}) => {
  const isTopNavEnabled = useFeatureFlag('top-nav-updates');
  return (
    <div className={getClassNameFor(s, 'root', classNameModifier)}>
      {extraChildren}
      <div className={getClassNameFor(s, 'innerWrapper', `${classNameModifier} ${isTopNavEnabled ? 'topNavUpdates' : ''}`)}>
        {children}
      </div>
    </div>
  );
};

const decorators = [
  withStyles(s),
];

export default decorateComponent(BareHeader, decorators);
